(() => {
  if (window.__fdhSpecialOrderLoaded) return;
  window.__fdhSpecialOrderLoaded = true;

  const PROPERTY_NAME = 'properties[Special Order]';
  const PROPERTY_VALUE = 'Ships in 2–4 Weeks – Non-Returnable. Cancellation or changes may not be possible.';
  const STYLE_ID = 'fdh-special-order-styles';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .product.js-product.fdh-special-order-active .backorder,
      .product.js-product.fdh-special-order-active product-inventory,
      .product.js-product.fdh-special-order-active .product-info__dynamic-checkout-button {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  function syncSpecialOrderState(productRoot, variantId) {
    if (!productRoot) return;

    const selector = `.fdh-special-order-notice[data-fdh-special-order-variant-id="${CSS.escape(String(variantId || ''))}"]`;
    const isSpecialOrder = Boolean(productRoot.querySelector(selector));

    productRoot.classList.toggle('fdh-special-order-active', isSpecialOrder);

    const form = productRoot.querySelector('form.js-product-form-main');
    if (!form) return;

    let input = form.querySelector('input[data-fdh-special-order-property]');

    if (isSpecialOrder) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = PROPERTY_NAME;
        input.dataset.fdhSpecialOrderProperty = 'true';
        form.appendChild(input);
      }
      input.value = PROPERTY_VALUE;
    } else if (input) {
      input.remove();
    }
  }

  function initProduct(productRoot) {
    if (!productRoot || productRoot.dataset.fdhSpecialOrderInitialized === 'true') return;
    productRoot.dataset.fdhSpecialOrderInitialized = 'true';

    const variantPicker = productRoot.querySelector('variant-picker');
    const variantLabel = productRoot.querySelector('variant-label[data-current-variant-id]');
    const form = productRoot.querySelector('form.js-product-form-main');
    const initialVariantId = form?.querySelector('input[name="id"]')?.value || variantLabel?.dataset.currentVariantId || '';

    syncSpecialOrderState(productRoot, initialVariantId);

    if (variantPicker) {
      variantPicker.addEventListener('on:variant:change', (event) => {
        syncSpecialOrderState(productRoot, event.detail?.variant?.id || '');
      });
    }
  }

  function initAll() {
    ensureStyles();
    document.querySelectorAll('.product.js-product').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
